import React, { useRef, useEffect } from 'react';

const StarField = ({ speedFactor = 1 }) => {
    const canvasRef = useRef(null);
    const speedRef = useRef(speedFactor);

    // Update the ref whenever the prop changes
    useEffect(() => {
        speedRef.current = speedFactor;
    }, [speedFactor]);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        let animationFrameId;

        const resizeCanvas = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };

        window.addEventListener('resize', resizeCanvas);
        resizeCanvas();

        const stars = [];
        const numStars = 200;

        for (let i = 0; i < numStars; i++) {
            stars.push({
                x: Math.random() * canvas.width,
                y: Math.random() * canvas.height,
                radius: Math.random() * 1.5,
                alpha: Math.random(),
                baseSpeed: Math.random() * 0.5 + 0.1
            });
        }

        const draw = () => {
            const currentSpeed = speedRef.current;

            // Dark space background
            // Use clearRect for transparent background if needed, but fillRect black is good for full bg
            ctx.fillStyle = '#000000';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            stars.forEach(star => {
                ctx.beginPath();
                ctx.arc(star.x, star.y, star.radius, 0, Math.PI * 2);
                ctx.fillStyle = `rgba(255, 255, 255, ${star.alpha})`;
                ctx.fill();

                // Move stars downwards (classical warp direction usually flows towards viewer or away)
                // Let's making them flow Downwards as if moving Forward into space
                star.y += (star.baseSpeed * currentSpeed);

                if (star.y > canvas.height) {
                    star.y = 0;
                    star.x = Math.random() * canvas.width;
                }
            });

            animationFrameId = requestAnimationFrame(draw);
        };

        draw();

        return () => {
            window.removeEventListener('resize', resizeCanvas);
            cancelAnimationFrame(animationFrameId);
        };
    }, []);

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                zIndex: -1,
                pointerEvents: 'none'
            }}
        />
    );
};

export default StarField;
